module.exports = "https://static.cdns.space/tarot-temp/img/the-juggler.b82ed1a9.webp";